module.exports = __webpack_public_path__ + "img/28_12.3f914966.png";